import { render, staticRenderFns } from "./committee.vue?vue&type=template&id=b9f42a3e&scoped=true&"
import script from "./committee.vue?vue&type=script&lang=js&"
export * from "./committee.vue?vue&type=script&lang=js&"
import style0 from "./committee.vue?vue&type=style&index=0&lang=css&"
import style1 from "./committee.vue?vue&type=style&index=1&id=b9f42a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f42a3e",
  null
  
)

export default component.exports